<!--
 * @Description: 
 * @Author: luckymiaow
 * @Date: 2022-04-29 15:13:52
 * @LastEditors: luckymiaow
-->
<script lang="ts" setup>
import { Checkbox as ACheckbox } from 'ant-design-vue';
import { useAttrs, useSlots, withDefaults } from 'vue';
import useForm from '../../form/src/useFormConfig';
import type { CheckboxBaseProps, CheckboxInjectConfig } from '../types';
import useSlot from '../../hooks/useSlot';
import useFormReadOnly from '../../hooks/useFormReadOnly';

const { getBindValue } = useForm<CheckboxInjectConfig & CheckboxBaseProps>({
  componentName: 'checkbox',
  attrs: useAttrs(),
});

useFormReadOnly(getBindValue);

const { useExcludeSlots } = useSlot({ slots: useSlots() }, []);
</script>

<template>
  <a-checkbox v-bind="getBindValue">
    <template v-for="(slot, key) in useExcludeSlots" :key="key" #[key]="scope">
      <slot :name="key" v-bind="scope ?? {}"> </slot>
    </template>
  </a-checkbox>
</template>
